module.exports = __webpack_public_path__ + "static/media/9.f2d58d23.jpg";